<template>
  <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="total"
      :options.sync="options"
      :loading="loading"
      :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100] }"
      class="elevation-12"
      dense
  >
    <template v-slot:top>
      <div class="px-4">
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select v-model="filters.region"
                      :items="$store.getters.appLogin.regions"
                      :item-value="item => item"
                      :item-text="item => item.name"
                      label="Область"
                      :clearable="true"
                      :error-messages="validationErrorMessages"
                      @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-autocomplete v-model="filters.area"
                            :items="sortedAreas"
                            :item-value="item => item"
                            :item-text="item => item.name"
                            label="Район"
                            :clearable="true"
                            :error-messages="validationErrorMessages"
                            @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-menu
                v-model="filterStartMenu"
                transition="scale-transition"
                offset-y
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
                :close-on-content-click="false"
            >
              <template v-slot:activator="{on}">
                <v-text-field
                    label="Начало даты поступления"
                    v-model="filterStartDisplayValue"
                    readonly
                    v-on="on"
                    :clearable="true"
                    @input="onChangeFilterStartDisplayValue"
                />
              </template>
              <v-date-picker
                  v-model="filters.start"
                  @change="onFilterStartChanged"
                  no-title
                  scrollable
                  locale="ru"
                  first-day-of-week="1"
              />
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-menu
                v-model="filterEndMenu"
                transition="scale-transition"
                offset-y
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
                :close-on-content-click="false"
            >
              <template v-slot:activator="{on}">
                <v-text-field
                    label="Конец даты поступления"
                    v-model="filterEndDisplayValue"
                    readonly
                    v-on="on"
                    :clearable="true"
                    @input="onChangeFilterEndDisplayValue"
                />
              </template>
              <v-date-picker
                  v-model="filters.end"
                  @change="onFilterEndChanged"
                  no-title
                  scrollable
                  locale="ru"
                  first-day-of-week="1"
              />
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select v-model="filters.isDistributed"
                      :items="isDistributedFilterOptions"
                      label="Распределено?"
                      @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select v-model="filters.isPrinted"
                      :items="isPrintedFilterOptions"
                      label="Распечатано?"
                      @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select v-model="filters.isPosted"
                      :items="isPostedFilterOptions"
                      label="Пост пакетировано?"
                      @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select v-model="filters.isPerformed"
                      :items="isPerformedFilterOptions"
                      label="Результат установлен?"
                      @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select v-model="filters.isTransferNotified"
                      :items="isTransferNotifiedFilterOptions"
                      label="Передача информирована в Шипокс?"
                      @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select v-model="filters.isTransferCompleted"
                      :items="isTransferCompletedFilterOptions"
                      label="Передача завершена?"
                      @change="onFiltersChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" v-if="allowIsExpressFilter">
            <v-select v-model="filters.isExpress"
                      :items="isExpressFilterOptions"
                      label="Срочное?"
                      @change="onFiltersChanged"
            />
          </v-col>

          <div class="col-12 d-block d-md-flex align-center flex-md-row flex-column">
            <v-col cols="12" md="6" class="d-flex align-center justify-center justify-md-start">
              <v-btn x-large color="primary" dark @click="onRefreshButtonClicked">Обновить</v-btn>
            </v-col>
            <v-col cols="12" md="6" class="d-flex align-center justify-center justify-md-end" :offset-lg="allowIsExpressFilter ? 0 : 0">
              <v-btn
                  v-if="allowDistributionByPostOffices"
                  x-large color="success"
                  class="float-right"
                  :disabled="false"
                  @click="onSendToPostOfficeClicked"
              >
                Отправить в пост отделение
              </v-btn>
            </v-col>
          </div>
        </v-row>
      </div>
    </template>

    <template v-slot:item="scope">
      <tr :class="{
                    'white--text black': scope.isPerformedNotTry,
                    'white--text warning darken -1': scope.isPerformedTry,
                    'green lighten-4': !scope.isPerformedTry && !scope.isPerformedNotTry && scope.isPacked,
                    'light-blue lighten-4': !scope.isPerformedTry && !scope.isPerformedNotTry && !scope.isPacked && scope.isPrinted,
                    'yellow lighten-1': !scope.isPerformedTry && !scope.isPerformedNotTry && !scope.isPacked && !scope.isPrinted && scope.isTransferNotified,
                    }">
        <td class="text-center pa-1">{{ scope.item.displayNumber }}</td>
        <td class="text-left pa-1">
          <router-link :to="{name: 'mail', params:{uid: scope.item.uid}}">
            {{ scope.item.uid }}
          </router-link>
          <span v-if="scope.item.isExpress" class="white--text red">
                        Срочно
                    </span>
        </td>
        <td class="pa-1">{{ scope.item.receiver }}</td>
        <td class="pa-1">{{ scope.item.region.name }}</td>
        <td class="pa-1">{{ scope.item.area.name }}</td>
        <td class="pa-1">{{ scope.item.address }}</td>
        <td class="text-center pa-1" style="width: 110px">
          <template v-if="scope.item.perform">
            {{ scope.item.perform.performType.name }}
          </template>
          <template v-else>
            Статус неустановлен
          </template>
        </td>
        <td class="text-center pa-1" style="width: 110px">
          {{ scope.item.createdOn.format('DD.MM.YYYY') }}
          <br>
          {{ scope.item.createdOn.format('HH:mm:ss') }}
        </td>
        <td class="text-center pa-1">
          <v-autocomplete v-model="scope.item.postIndex"
                          :items="getRegionPostIndexes(scope.item)"
                          auto-select-first
                          :item-value="item => item"
                          :item-text="item => `${item.postCode} - ${item.name}`"
                          :clearable="true"
                          :disabled="$store.getters.appIsOperatorLogin"
                          :hide-details="true"
                          label="Пост индекс"
                          outlined
          />
        </td>
      </tr>
    </template>
    <template v-slot:no-data>
      Писем не найдено
    </template>
  </v-data-table>
</template>

<script>
import _ from "underscore";
import {DXA} from "@/enums/client";
import {required} from "vuelidate/lib/validators";
import {validationMixin} from 'vuelidate'
import Moment from "moment";
import $store from "@/store"

export default {
  name: "DistributionMailsDataTable",
  mixins: [validationMixin],
  props: {
    mails: {
      type: Array,
      default: () => {
        return [];
      }
    },
    postIndexes: {
      type: Array,
      default: () => {
        return [];
      }
    },
    total: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    allowDistributionByPostOffices: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: {
        sortBy: ['createdOn'],
        sortDesc: [true],
        page: 1,
        itemsPerPage: 50,
      },
      filters: {
        region: null,
        area: null,
        start: null,
        end: null,
        isDistributed: false,
        isPrinted: false,
        isPosted: false,
        isPerformed: false,
        isTransferNotified: null,
        isTransferCompleted: null,
        postIndex: null,
        isExpress: null
      },
      filterStartMenu: false,
      filterEndMenu: false,
      filterStartDisplayValue: '',
      filterEndDisplayValue: ''
    };
  },
  computed: {
    items() {
      let number = 1;
      let skip = this.skip;
      return _.map(this.mails, m => {
        m.displayNumber = skip + (number++)
        return m
      })
    },
    sortedAreas(){
      var selectedRegionId = this.filters.region?.id;
      if(selectedRegionId > 0){
        return $store.getters.appLogin.areas.filter(item => item.region?.id === selectedRegionId)
      }
      else{
        return $store.getters.appLogin.areas;
      }
    },
    headers() {
      const headers = [];

      headers.push({
        text: '№',
        align: 'center',
        sortable: false,
        value: 'displayNumber'
      })

      headers.push({
        text: 'Идентификатор',
        align: 'left',
        sortable: false,
        value: 'uid'
      })

      headers.push({
        text: 'Получатель',
        align: 'left',
        sortable: false,
        value: 'receiver'
      })

      headers.push({
        text: 'Область',
        align: 'center',
        sortable: false,
        value: 'region'
      })

      headers.push({
        text: 'Район',
        align: 'center',
        sortable: false,
        value: 'area'
      })

      headers.push({
        text: 'Адрес',
        align: 'left',
        sortable: false,
        value: 'address'
      })

      headers.push({
        text: 'Состояние',
        align: 'left',
        sortable: false,
        value: 'perform.performType.name'
      })

      headers.push({
        text: 'Дата поступления',
        align: 'center',
        sortable: true,
        value: 'createdOn'
      })

      headers.push({
        text: 'Пост индекс',
        align: 'center',
        sortable: false,
        value: 'postIndex'
      })

      return headers;
    },
    skip() {
      return (this.options.page - 1) * this.options.itemsPerPage
    },
    validationErrorMessages() {
      const errors = [];
      if (this.$v.$dirty) {
        if (!this.$v.filters.region.required)
          errors.push('Выберите регион');
        if (!this.$v.filters.area.required)
          errors.push('Выберите район');
      }
      return errors;
    },

    isPrintedFilterOptions() {
      return [
        {text: 'Да', value: true},
        {text: 'Нет', value: false},
        {text: 'Неважно', value: null},
      ];
    },
    isDistributedFilterOptions() {
      return [
        {text: 'Да', value: true},
        {text: 'Нет', value: false},
        {text: 'Неважно', value: null},
      ];
    },
    isPostedFilterOptions() {
      return [
        {text: 'Да', value: true},
        {text: 'Нет', value: false},
        {text: 'Неважно', value: null}
      ];
    },
    isPerformedFilterOptions() {
      return [
        {text: 'Да', value: true},
        {text: 'Нет', value: false},
        {text: 'Неважно', value: null}
      ];
    },
    isTransferNotifiedFilterOptions() {
      return [
        {text: 'Да', value: true},
        {text: 'Нет', value: false},
        {text: 'Неважно', value: null}
      ];
    },
    isTransferCompletedFilterOptions() {
      return [
        {text: 'Да', value: true},
        {text: 'Нет', value: false},
        {text: 'Неважно', value: null}
      ];
    },
    isExpressFilterOptions() {
      return [
        {text: 'Да', value: true},
        {text: 'Нет', value: false},
        {text: 'Неважно', value: null}
      ];
    },

    allowIsExpressFilter() {
      return this.$store.getters.appActiveClient === DXA;
    }
  },
  validations: {
    filters: {
      region: {
        required
      },
      area: {
        required
      }
    }
  },
  methods: {
    getRegionPostIndexes(item) {
      let vm = this;
      return _.filter(vm.$store.getters.appPostIndexes, function (postIndex) {
        return item.region.id === postIndex.postRegionCode
      })
    },
    disableSendToPostOfficeButton() {
      return this.filters.region != null && this.filters.area != null
    },
    updateItems() {
      this.$emit("update", this.options, this.filters)
    },
    sendToPostOffice() {
      this.$emit('send-to-post-office', this.options, this.filters)
    },

    onFiltersChanged() {
      if (this.options.page !== 1)
        this.options.page = 1;
      else
        this.updateItems();
    },
    onRefreshButtonClicked() {
      this.updateItems();
    },
    onFilterStartChanged() {
      if (this.filters.start) {
        this.filterStartDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
      } else {
        this.filterStartDisplayValue = ''
      }

      this.filterStartMenu = false
      this.updateItems()
    },
    onFilterEndChanged() {
      if (this.filters.end) {
        this.filterEndDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
      } else {
        this.filterEndDisplayValue = ''
      }

      this.filterEndMenu = false
      this.updateItems()
    },
    onChangeFilterStartDisplayValue() {
      this.filters.start = null;
      this.updateItems()
    },
    onChangeFilterEndDisplayValue() {
      this.filters.end = null;
      this.updateItems()
    },
    onSendToPostOfficeClicked() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.sendToPostOffice()
      }
    }
  },
  watch: {
    options: {
      handler() {
        this.updateItems()
      }
    }
  },
  created() {
    this.filters.region = this.$store.getters.appLogin.regions[0]
  }
}
</script>

<style scoped>

</style>